import Vue from "vue"

export default {
  setMetricsLoading(state, loading) {
    state.loading = loading
  },
  updateMetrics(state, metrics) {
    Vue.set(state, 'all', metrics)
  },
  setMetric(state, metric) {
    const all = state.all
    for (let index = 0; index < all.length; index++) {
      if (all[index].id === metric.id) {
        all[index] = metric
      }
    }
    Vue.set(state, 'all', all)
  },
  deleteMetric(state, metric) {
    const metricIndex = state.all.findIndex(m => m.id === metric.id)
    if (metricIndex>=0) {
      state.all.splice(metricIndex, 1)
    }
    Vue.set(state, 'all', state.all)
  },
  addMetric(state, metric) {
    state.all.push(metric)
    Vue.set(state, 'all', state.all)
  }
}